import { Component } from '@angular/core';

@Component({
  selector: 'app-provider-box-commit',
  templateUrl: './provider-box-commit.component.html',
  styleUrls: ['./provider-box-commit.component.scss']
})
export class ProviderBoxCommitComponent {}
